import { render, staticRenderFns } from "./NovelBookShelf.vue?vue&type=template&id=74e74644&scoped=true&"
import script from "./NovelBookShelf.vue?vue&type=script&lang=js&"
export * from "./NovelBookShelf.vue?vue&type=script&lang=js&"
import style0 from "./NovelBookShelf.vue?vue&type=style&index=0&id=74e74644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e74644",
  null
  
)

export default component.exports